export enum PROMOTION_EVENTS {
    READY = "READY",
    TRANSACTION_FINISHED = "TRANSACTION_FINISHED",
    UPDATE_SETTINGS = "UPDATE_SETTINGS",
    CALCULATE = "CALCULATE",
    EVERYDAY_PRICE = "EVERYDAY_PRICE",
    CALCULATE_LOYALTY = "CALCULATE_LOYALTY",
    SETUP_DATA_SOURCES = "SETUP_DATA_SOURCES",
    SIMULATE = "SIMULATE",
    SYNC_FINISHED = "SYNC_FINISHED",
}

export class PromotionCalculationInvalid extends Error {
    constructor() {
        super("Promotion calculation is invalid");
    }
}
